import {CustomerScreen} from "../screens";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {Routes} from "../utils";


export default function CustomerContainer(props) {
    const dimensions = useSelector(({main}) => main.dimensions)
    const navigate = useNavigate()


    useEffect(() => {
        if (!dimensions) {
            navigate(Routes.configuration)
        }
    }, [])

    if (!dimensions)
        return null
    return (
        <CustomerScreen/>
    )
}
